"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INSTALLMENT = exports.MINIMUM_PRICE = void 0;
exports.MINIMUM_PRICE = 45;
exports.INSTALLMENT = 4;
